/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: jOhB8EyLNa7v

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { Dialog } from "@plasmicpkgs/radix-ui";
import { DialogContent } from "@plasmicpkgs/radix-ui";
import { HiddenIfEmptyContainer } from "@myevaluations/myevals-plasmic-utils/dist/code-components/HiddenIfEmptyContainer/HiddenIfEmptyContainer"; // plasmic-import: RR3sVLmcSBJ_/codeComponent
import { DialogTitle } from "@plasmicpkgs/radix-ui";
import { StateProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/StateProvider/StateProvider"; // plasmic-import: OaGu0RHjgthJ/codeComponent
import { DialogClose } from "@plasmicpkgs/radix-ui";
import ModalCloseButton from "../../ModalCloseButton"; // plasmic-import: mUrFb8Eka3V0/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicLoginTroubleshootingModal.module.css"; // plasmic-import: jOhB8EyLNa7v/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon

createPlasmicElementProxy;

export type PlasmicLoginTroubleshootingModal__VariantMembers = {};
export type PlasmicLoginTroubleshootingModal__VariantsArgs = {};
type VariantPropType = keyof PlasmicLoginTroubleshootingModal__VariantsArgs;
export const PlasmicLoginTroubleshootingModal__VariantProps =
  new Array<VariantPropType>();

export type PlasmicLoginTroubleshootingModal__ArgsType = {
  open?: string;
  onOpenChange?: (val: string) => void;
};
type ArgPropType = keyof PlasmicLoginTroubleshootingModal__ArgsType;
export const PlasmicLoginTroubleshootingModal__ArgProps =
  new Array<ArgPropType>("open", "onOpenChange");

export type PlasmicLoginTroubleshootingModal__OverridesType = {
  root?: Flex__<"div">;
  dialogCore?: Flex__<typeof Dialog>;
  freeBox?: Flex__<"div">;
  dialogContent?: Flex__<typeof DialogContent>;
  hiddenIfEmptyContainer?: Flex__<typeof HiddenIfEmptyContainer>;
  dialogTitle?: Flex__<typeof DialogTitle>;
  openProvider?: Flex__<typeof StateProvider>;
  overlayMask?: Flex__<"div">;
  stack?: Flex__<"div">;
  modal?: Flex__<"div">;
  top?: Flex__<"div">;
  header?: Flex__<"div">;
  left?: Flex__<"div">;
  link?: Flex__<"h4">;
  dialogClose?: Flex__<typeof DialogClose>;
  modalCloseButton?: Flex__<typeof ModalCloseButton>;
  intro?: Flex__<"div">;
  title?: Flex__<"h2">;
  desc?: Flex__<"p">;
  bulletPoints?: Flex__<"div">;
  section?: Flex__<"div">;
  bulletPoints2?: Flex__<"div">;
  footer?: Flex__<"div">;
  button?: Flex__<typeof Button>;
};

export interface DefaultLoginTroubleshootingModalProps {
  open?: string;
  onOpenChange?: (val: string) => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicLoginTroubleshootingModal__RenderFunc(props: {
  variants: PlasmicLoginTroubleshootingModal__VariantsArgs;
  args: PlasmicLoginTroubleshootingModal__ArgsType;
  overrides: PlasmicLoginTroubleshootingModal__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "openProvider.value",
        type: "writable",
        variableType: "text",

        valueProp: "open",
        onChangeProp: "onOpenChange"
      },
      {
        path: "dialogCore.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          (() => {
            try {
              return $state.openProvider.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <Dialog
        data-plasmic-name={"dialogCore"}
        data-plasmic-override={overrides.dialogCore}
        className={classNames("__wab_instance", sty.dialogCore)}
        defaultOpen={(() => {
          try {
            return $state.openProvider.value;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        modal={true}
        onOpenChange={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, ["dialogCore", "open"]).apply(
            null,
            eventArgs
          );
        }}
        open={generateStateValueProp($state, ["dialogCore", "open"])}
        overlayClassName={classNames({ [sty["pcls_CmcAd0NOoyMp"]]: true })}
        themeResetClass={classNames(
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames
        )}
        triggerSlot={null}
      >
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
        >
          <DialogContent
            data-plasmic-name={"dialogContent"}
            data-plasmic-override={overrides.dialogContent}
            className={classNames("__wab_instance", sty.dialogContent)}
            enterAnimations={["slide-in-from-right"]}
            enterDuration={0.3}
            exitAnimations={["slide-out-to-right"]}
            exitDuration={0.25}
            themeResetClass={classNames(
              projectcss.root_reset,
              projectcss.plasmic_default_styles,
              projectcss.plasmic_mixins,
              styleTokensClassNames
            )}
          >
            <HiddenIfEmptyContainer
              data-plasmic-name={"hiddenIfEmptyContainer"}
              data-plasmic-override={overrides.hiddenIfEmptyContainer}
              className={classNames(
                "__wab_instance",
                sty.hiddenIfEmptyContainer
              )}
            >
              <DialogTitle
                data-plasmic-name={"dialogTitle"}
                data-plasmic-override={overrides.dialogTitle}
                children={null}
                className={classNames("__wab_instance", sty.dialogTitle)}
              />
            </HiddenIfEmptyContainer>
            <StateProvider
              data-plasmic-name={"openProvider"}
              data-plasmic-override={overrides.openProvider}
              forceValue={(() => {
                try {
                  return $state.dialogCore.open;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              onChange={async (...eventArgs: any) => {
                generateStateOnChangeProp($state, [
                  "openProvider",
                  "value"
                ]).apply(null, eventArgs);
              }}
              value={generateStateValueProp($state, ["openProvider", "value"])}
            />

            {(hasVariant(globalVariants, "mobile", "mobile") ? false : true) ? (
              <div
                data-plasmic-name={"overlayMask"}
                data-plasmic-override={overrides.overlayMask}
                className={classNames(projectcss.all, sty.overlayMask)}
                onClick={async event => {
                  const $steps = {};

                  $steps["updateDialogCoreOpen"] = true
                    ? (() => {
                        const actionArgs = {
                          variable: {
                            objRoot: $state,
                            variablePath: ["dialogCore", "open"]
                          },
                          operation: 0,
                          value: false
                        };
                        return (({
                          variable,
                          value,
                          startIndex,
                          deleteCount
                        }) => {
                          if (!variable) {
                            return;
                          }
                          const { objRoot, variablePath } = variable;

                          $stateSet(objRoot, variablePath, value);
                          return value;
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["updateDialogCoreOpen"] != null &&
                    typeof $steps["updateDialogCoreOpen"] === "object" &&
                    typeof $steps["updateDialogCoreOpen"].then === "function"
                  ) {
                    $steps["updateDialogCoreOpen"] = await $steps[
                      "updateDialogCoreOpen"
                    ];
                  }
                }}
                style={(() => {
                  try {
                    return {
                      width: "calc(100% - 560px)"
                    };
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
              />
            ) : null}
            <div
              data-plasmic-name={"stack"}
              data-plasmic-override={overrides.stack}
              className={classNames(projectcss.all, sty.stack)}
            >
              <div
                data-plasmic-name={"modal"}
                data-plasmic-override={overrides.modal}
                className={classNames(projectcss.all, sty.modal)}
              >
                <div
                  data-plasmic-name={"top"}
                  data-plasmic-override={overrides.top}
                  className={classNames(projectcss.all, sty.top)}
                >
                  <div
                    data-plasmic-name={"header"}
                    data-plasmic-override={overrides.header}
                    className={classNames(projectcss.all, sty.header)}
                  >
                    <div
                      data-plasmic-name={"left"}
                      data-plasmic-override={overrides.left}
                      className={classNames(projectcss.all, sty.left)}
                    >
                      <h4
                        data-plasmic-name={"link"}
                        data-plasmic-override={overrides.link}
                        className={classNames(
                          projectcss.all,
                          projectcss.h4,
                          projectcss.__wab_text,
                          sty.link
                        )}
                      >
                        {"Login"}
                      </h4>
                    </div>
                    <DialogClose
                      data-plasmic-name={"dialogClose"}
                      data-plasmic-override={overrides.dialogClose}
                      className={classNames("__wab_instance", sty.dialogClose)}
                    >
                      <ModalCloseButton
                        data-plasmic-name={"modalCloseButton"}
                        data-plasmic-override={overrides.modalCloseButton}
                        className={classNames(
                          "__wab_instance",
                          sty.modalCloseButton
                        )}
                        onClick={async () => {
                          const $steps = {};

                          $steps["updateDialogCoreOpen"] = true
                            ? (() => {
                                const actionArgs = {
                                  variable: {
                                    objRoot: $state,
                                    variablePath: ["dialogCore", "open"]
                                  },
                                  operation: 0,
                                  value: false
                                };
                                return (({
                                  variable,
                                  value,
                                  startIndex,
                                  deleteCount
                                }) => {
                                  if (!variable) {
                                    return;
                                  }
                                  const { objRoot, variablePath } = variable;

                                  $stateSet(objRoot, variablePath, value);
                                  return value;
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["updateDialogCoreOpen"] != null &&
                            typeof $steps["updateDialogCoreOpen"] ===
                              "object" &&
                            typeof $steps["updateDialogCoreOpen"].then ===
                              "function"
                          ) {
                            $steps["updateDialogCoreOpen"] = await $steps[
                              "updateDialogCoreOpen"
                            ];
                          }
                        }}
                      />
                    </DialogClose>
                  </div>
                  <div
                    data-plasmic-name={"intro"}
                    data-plasmic-override={overrides.intro}
                    className={classNames(projectcss.all, sty.intro)}
                  >
                    <h2
                      data-plasmic-name={"title"}
                      data-plasmic-override={overrides.title}
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.title
                      )}
                    >
                      {"Login Troubleshooting"}
                    </h2>
                    <p
                      data-plasmic-name={"desc"}
                      data-plasmic-override={overrides.desc}
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.desc
                      )}
                    >
                      {
                        "If you can't sign in to MyEvaluations.com with your username and password, try the following:"
                      }
                    </p>
                    <div
                      data-plasmic-name={"bulletPoints"}
                      data-plasmic-override={overrides.bulletPoints}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.bulletPoints
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul__hhdqx
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__i4A4J
                              )}
                            >
                              <React.Fragment>
                                <React.Fragment>
                                  {"Check that you are logging in at "}
                                </React.Fragment>
                                {
                                  <PlasmicLink__
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.a,
                                      projectcss.__wab_text,
                                      projectcss.plasmic_default__inline,
                                      sty.link___3EwYt
                                    )}
                                    component={Link}
                                    href={"https://www.MyEvaluations.com"}
                                    platform={"nextjs"}
                                  >
                                    {"https://www.MyEvaluations.com"}
                                  </PlasmicLink__>
                                }
                                <React.Fragment>
                                  {" and not similar looking site."}
                                </React.Fragment>
                              </React.Fragment>
                            </li>
                          </ul>
                        }
                        <React.Fragment>{"\n"}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul__xuwQe
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__l47Xi
                              )}
                            >
                              {
                                'Check that your browser displays the "s" after "http" in order to confirm a secure connection.'
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>{"\n"}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul__qd75C
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__s3WBc
                              )}
                            >
                              {
                                "Update the Favorite listing in your browser with the correct web address.\n"
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>{"\n"}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul__dd08V
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__j8Jug
                              )}
                            >
                              <React.Fragment>
                                <React.Fragment>
                                  {
                                    "Make sure that you typed your username and password correctly. Passwords are not case sensitive. If you've forgotten your username and/or password, "
                                  }
                                </React.Fragment>
                                {
                                  <PlasmicLink__
                                    aria-label={"Go to forgot password page"}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.a,
                                      projectcss.__wab_text,
                                      projectcss.plasmic_default__inline,
                                      sty.link__aQw2D
                                    )}
                                    component={Link}
                                    href={`/forgot-password`}
                                    platform={"nextjs"}
                                    title={"Go to forgot password page"}
                                  >
                                    {"try to retrieve it"}
                                  </PlasmicLink__>
                                }
                                <React.Fragment>
                                  {" and make certain it is correct.\n"}
                                </React.Fragment>
                              </React.Fragment>
                            </li>
                          </ul>
                        }
                        <React.Fragment>{"\n"}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul__g0Jjl
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__sEFhK
                              )}
                            >
                              {
                                "If your department has not renewed it MyEvaluations.com account, it may be deactivated. If your department's account is deactivated, please contact your department for assistance.Reset the cookies saved on your computer.\n"
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>{"\n"}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul__pwnkN
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__jkhW4
                              )}
                            >
                              {
                                "Make sure that you have configured your browser to allow cookies. If your browser doesn\u2019t allow cookies, you can\u2019t sign in with your username and password. (Cookie is a small text file, created by a website, that stores information on your computer. For example, your preferences when visiting those sites.)"
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>{""}</React.Fragment>
                      </React.Fragment>
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"section"}
                    data-plasmic-override={overrides.section}
                    className={classNames(projectcss.all, sty.section)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__gYxi
                      )}
                    >
                      {"Configure your browser to allow cookies"}
                    </div>
                    <div
                      data-plasmic-name={"bulletPoints2"}
                      data-plasmic-override={overrides.bulletPoints2}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.bulletPoints2
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>{""}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul__uooNw
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__nBzNu
                              )}
                            >
                              {
                                "In Windows Internet Explorer, click Internet Options on the Tools menu."
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>{"\n"}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul__ccpQi
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__gQgf3
                              )}
                            >
                              {
                                "Click the Privacy tab, and then click Advanced."
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>{"\n"}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul___5Pv0
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__ghPt4
                              )}
                            >
                              {
                                "Select the Override automatic cookie handling check box.\n"
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>{"\n"}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul__kVs19
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li__wn1Up
                              )}
                            >
                              {
                                "If you're using a shared computer, select the Always allow session cookies check box.\u2013or\u2013If you're using a private computer, under First-party Cookies, click Accept.\n"
                              }
                            </li>
                          </ul>
                        }
                        <React.Fragment>{"\n"}</React.Fragment>
                        {
                          <ul
                            className={classNames(
                              projectcss.all,
                              projectcss.ul,
                              sty.ul__bT3L
                            )}
                          >
                            <li
                              className={classNames(
                                projectcss.all,
                                projectcss.li,
                                projectcss.__wab_text,
                                sty.li___6ZCe
                              )}
                            >
                              {"Click OK, and then click OK again."}
                            </li>
                          </ul>
                        }
                        <React.Fragment>{""}</React.Fragment>
                      </React.Fragment>
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"footer"}
                  data-plasmic-override={overrides.footer}
                  className={classNames(projectcss.all, sty.footer)}
                >
                  <Button
                    data-plasmic-name={"button"}
                    data-plasmic-override={overrides.button}
                    className={classNames("__wab_instance", sty.button)}
                    color={"sky"}
                    onClick={async event => {
                      const $steps = {};

                      $steps["updateDialogCoreOpen"] = true
                        ? (() => {
                            const actionArgs = {
                              variable: {
                                objRoot: $state,
                                variablePath: ["dialogCore", "open"]
                              },
                              operation: 0,
                              value: false
                            };
                            return (({
                              variable,
                              value,
                              startIndex,
                              deleteCount
                            }) => {
                              if (!variable) {
                                return;
                              }
                              const { objRoot, variablePath } = variable;

                              $stateSet(objRoot, variablePath, value);
                              return value;
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["updateDialogCoreOpen"] != null &&
                        typeof $steps["updateDialogCoreOpen"] === "object" &&
                        typeof $steps["updateDialogCoreOpen"].then ===
                          "function"
                      ) {
                        $steps["updateDialogCoreOpen"] = await $steps[
                          "updateDialogCoreOpen"
                        ];
                      }
                    }}
                    size={"large"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__hwecz
                      )}
                    >
                      {"Close"}
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          </DialogContent>
        </div>
      </Dialog>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "dialogCore",
    "freeBox",
    "dialogContent",
    "hiddenIfEmptyContainer",
    "dialogTitle",
    "openProvider",
    "overlayMask",
    "stack",
    "modal",
    "top",
    "header",
    "left",
    "link",
    "dialogClose",
    "modalCloseButton",
    "intro",
    "title",
    "desc",
    "bulletPoints",
    "section",
    "bulletPoints2",
    "footer",
    "button"
  ],
  dialogCore: [
    "dialogCore",
    "freeBox",
    "dialogContent",
    "hiddenIfEmptyContainer",
    "dialogTitle",
    "openProvider",
    "overlayMask",
    "stack",
    "modal",
    "top",
    "header",
    "left",
    "link",
    "dialogClose",
    "modalCloseButton",
    "intro",
    "title",
    "desc",
    "bulletPoints",
    "section",
    "bulletPoints2",
    "footer",
    "button"
  ],
  freeBox: [
    "freeBox",
    "dialogContent",
    "hiddenIfEmptyContainer",
    "dialogTitle",
    "openProvider",
    "overlayMask",
    "stack",
    "modal",
    "top",
    "header",
    "left",
    "link",
    "dialogClose",
    "modalCloseButton",
    "intro",
    "title",
    "desc",
    "bulletPoints",
    "section",
    "bulletPoints2",
    "footer",
    "button"
  ],
  dialogContent: [
    "dialogContent",
    "hiddenIfEmptyContainer",
    "dialogTitle",
    "openProvider",
    "overlayMask",
    "stack",
    "modal",
    "top",
    "header",
    "left",
    "link",
    "dialogClose",
    "modalCloseButton",
    "intro",
    "title",
    "desc",
    "bulletPoints",
    "section",
    "bulletPoints2",
    "footer",
    "button"
  ],
  hiddenIfEmptyContainer: ["hiddenIfEmptyContainer", "dialogTitle"],
  dialogTitle: ["dialogTitle"],
  openProvider: ["openProvider"],
  overlayMask: ["overlayMask"],
  stack: [
    "stack",
    "modal",
    "top",
    "header",
    "left",
    "link",
    "dialogClose",
    "modalCloseButton",
    "intro",
    "title",
    "desc",
    "bulletPoints",
    "section",
    "bulletPoints2",
    "footer",
    "button"
  ],
  modal: [
    "modal",
    "top",
    "header",
    "left",
    "link",
    "dialogClose",
    "modalCloseButton",
    "intro",
    "title",
    "desc",
    "bulletPoints",
    "section",
    "bulletPoints2",
    "footer",
    "button"
  ],
  top: [
    "top",
    "header",
    "left",
    "link",
    "dialogClose",
    "modalCloseButton",
    "intro",
    "title",
    "desc",
    "bulletPoints",
    "section",
    "bulletPoints2"
  ],
  header: ["header", "left", "link", "dialogClose", "modalCloseButton"],
  left: ["left", "link"],
  link: ["link"],
  dialogClose: ["dialogClose", "modalCloseButton"],
  modalCloseButton: ["modalCloseButton"],
  intro: ["intro", "title", "desc", "bulletPoints"],
  title: ["title"],
  desc: ["desc"],
  bulletPoints: ["bulletPoints"],
  section: ["section", "bulletPoints2"],
  bulletPoints2: ["bulletPoints2"],
  footer: ["footer", "button"],
  button: ["button"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  dialogCore: typeof Dialog;
  freeBox: "div";
  dialogContent: typeof DialogContent;
  hiddenIfEmptyContainer: typeof HiddenIfEmptyContainer;
  dialogTitle: typeof DialogTitle;
  openProvider: typeof StateProvider;
  overlayMask: "div";
  stack: "div";
  modal: "div";
  top: "div";
  header: "div";
  left: "div";
  link: "h4";
  dialogClose: typeof DialogClose;
  modalCloseButton: typeof ModalCloseButton;
  intro: "div";
  title: "h2";
  desc: "p";
  bulletPoints: "div";
  section: "div";
  bulletPoints2: "div";
  footer: "div";
  button: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicLoginTroubleshootingModal__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicLoginTroubleshootingModal__VariantsArgs;
    args?: PlasmicLoginTroubleshootingModal__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicLoginTroubleshootingModal__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicLoginTroubleshootingModal__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLoginTroubleshootingModal__ArgProps,
          internalVariantPropNames:
            PlasmicLoginTroubleshootingModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLoginTroubleshootingModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLoginTroubleshootingModal";
  } else {
    func.displayName = `PlasmicLoginTroubleshootingModal.${nodeName}`;
  }
  return func;
}

export const PlasmicLoginTroubleshootingModal = Object.assign(
  // Top-level PlasmicLoginTroubleshootingModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dialogCore: makeNodeComponent("dialogCore"),
    freeBox: makeNodeComponent("freeBox"),
    dialogContent: makeNodeComponent("dialogContent"),
    hiddenIfEmptyContainer: makeNodeComponent("hiddenIfEmptyContainer"),
    dialogTitle: makeNodeComponent("dialogTitle"),
    openProvider: makeNodeComponent("openProvider"),
    overlayMask: makeNodeComponent("overlayMask"),
    stack: makeNodeComponent("stack"),
    modal: makeNodeComponent("modal"),
    top: makeNodeComponent("top"),
    header: makeNodeComponent("header"),
    left: makeNodeComponent("left"),
    link: makeNodeComponent("link"),
    dialogClose: makeNodeComponent("dialogClose"),
    modalCloseButton: makeNodeComponent("modalCloseButton"),
    intro: makeNodeComponent("intro"),
    title: makeNodeComponent("title"),
    desc: makeNodeComponent("desc"),
    bulletPoints: makeNodeComponent("bulletPoints"),
    section: makeNodeComponent("section"),
    bulletPoints2: makeNodeComponent("bulletPoints2"),
    footer: makeNodeComponent("footer"),
    button: makeNodeComponent("button"),

    // Metadata about props expected for PlasmicLoginTroubleshootingModal
    internalVariantProps: PlasmicLoginTroubleshootingModal__VariantProps,
    internalArgProps: PlasmicLoginTroubleshootingModal__ArgProps
  }
);

export default PlasmicLoginTroubleshootingModal;
/* prettier-ignore-end */
